import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import Slider from "./Slider";

export default function About() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/asmb2.jpg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Facilities
          </div>
        </div>

        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            textAlign: "justify",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginBottom: "50px",
            }}
          >
            Hostel
          </div>
          <b>
            {" "}
            At SLV INTERNATIONAL SCHOOL, we are proud to provide our male
            students with comfortable, secure, and well-maintained hostel
            facilities. Our hostel is designed to foster a community
            environment, promoting both academic and personal growth. The rooms
            are designed for comfort, with provisions for both single and shared
            accommodation. The hostel is equipped with all necessary amenities,
            including study areas, recreational facilities, and Wi-Fi
            connectivity, to ensure a conducive living and learning environment.
          </b>
          <br />
          <br />
          In addition to the physical facilities, we place great emphasis on the
          overall wellbeing of our hostel residents. The hostel administration
          is always available to assist students and address their concerns
          promptly. Regular safety and security measures are in place to ensure
          the wellbeing of the residents. We also promote various activities
          aimed at community building and recreational engagement to provide a
          holistic hostel life. SLV INTERNATIONAL SCHOOL’s hostel is not just a
          place to stay, but a space that contributes significantly to our
          students’ overall college experience.
        </div>
        <div className="aboutabout">
          <div
            style={{
              fontSize: "28px",
              fontFamily: "Montserrat",
              textAlign: "left",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
              marginBottom: "25px",
            }}
          >
            Comfortable and Secure Living Spaces
          </div>
          <div
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            The hostel at SLV INTERNATIONAL SCHOOL offers a safe, comfortable,
            and nurturing environment where students can focus on their academic
            and personal growth. The rooms are spacious and well-ventilated,
            with modern furnishings that ensure a cozy and home-like atmosphere.
            Each room is equipped with individual study desks, ample storage
            space, and comfortable beds to cater to the needs of young scholars.
            The hostel provides 24/7 security with CCTV surveillance, secure
            entry points, and regular patrols to ensure the safety of all
            residents. Additionally, a dedicated hostel warden is always
            available to address the students' concerns, ensuring a peaceful and
            supportive living environment.
          </div>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Holistic Development and Recreation
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                SLV INTERNATIONAL SCHOOL's hostel emphasizes the holistic
                development of its residents, offering a balanced mix of
                academics, extracurricular activities, and recreation. The
                hostel has designated study areas for uninterrupted learning and
                access to resources such as libraries and computer labs. To
                promote physical fitness and well-being, the hostel features
                sports facilities, including a gym, basketball court, and a
                playground, where students can engage in various activities.
                Regularly organized events, such as movie nights, talent shows,
                and cultural programs, provide opportunities for students to
                relax and bond with their peers, fostering a sense of community
                and belonging among residents.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Healthy and Nutritious Dining
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Ensuring the well-being of our students is a top priority at the
                SLV INTERNATIONAL SCHOOL boys' hostel, and this extends to
                providing nutritious meals that support their growth and energy
                needs. The hostel's dining hall offers a variety of balanced
                meals, prepared under strict hygiene standards by experienced
                chefs. The menu is thoughtfully designed to include a wide range
                of dishes that cater to different tastes and dietary
                requirements, ensuring that students enjoy a healthy and varied
                diet. Regular feedback from students is encouraged to
                continuously improve the dining experience. The dining area is
                also a social hub where students come together to share meals,
                fostering friendships and a sense of camaraderie.
              </div>
            </Grid>
          </Grid>
        </div>

        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
            textAlign: "justify",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginBottom: "50px",
            }}
          >
            Playground
          </div>
          <b>
            {" "}
            SLV INTERNATIONAL SCHOOL boasts a spacious and well-equipped
            playground, fostering an active and vibrant sports culture among our
            students. This expansive space serves as a platform for students to
            engage in various sports and recreational activities, contributing
            to their physical well-being and promoting a healthy lifestyle. The
            playground is equipped for a range of sports such as football,
            cricket, basketball, and more, enabling students to pursue their
            athletic interests alongside their academic pursuits.
          </b>
          <br />
          <br />
          The playground at SLV INTERNATIONAL SCHOOL is more than just a
          physical space; it is an arena that fosters teamwork, leadership, and
          sportsmanship among students. Through various inter-collegiate and
          intra-collegiate tournaments, students have the opportunity to
          showcase their athletic prowess and build a sense of camaraderie. The
          memories and friendships made on this playground often last a
          lifetime. At SLV INTERNATIONAL SCHOOL, we believe in the holistic
          development of our students, and our playground plays a crucial role
          in fulfilling this mission.
        </div>
        <div className="aboutabout">
          <div
            style={{
              fontSize: "28px",
              fontFamily: "Montserrat",
              textAlign: "justify",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryColor
                  : themeStyle.primaryColor,
              fontWeight: "bold",
              marginBottom: "25px",
            }}
          >
            A Dynamic Space for Play and Learning
          </div>
          <div
            style={{
              fontSize: state.auth.isMobile ? "18px" : "25px",
              fontFamily: "Montserrat",
              textAlign: "justify",
            }}
          >
            The playground at SLV INTERNATIONAL SCHOOL is a vibrant and
            expansive area designed to support both physical activity and
            creative play. It features a range of modern equipment, including
            swings, slides, climbing structures, and sports facilities, catering
            to children of all ages. The playground’s design encourages
            exploration and imagination, with interactive play zones that
            stimulate cognitive and physical development. Safe, cushioned
            surfaces ensure that children can play freely while minimizing the
            risk of injury. This space not only provides an outlet for physical
            energy but also fosters social interaction and teamwork, essential
            for holistic child development.
          </div>
        </div>
        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Encouraging Physical Fitness and Fun
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Physical fitness is a key component of our educational
                philosophy, and the SLV INTERNATIONAL SCHOOL playground is
                instrumental in promoting an active lifestyle among students.
                The playground includes various sports courts and fields for
                activities such as basketball, soccer, and athletics,
                encouraging students to engage in healthy competition and
                develop their athletic skills. Regularly scheduled sports events
                and physical education classes make full use of these
                facilities, helping students build endurance, coordination, and
                teamwork. By integrating fun with fitness, the playground
                supports students' overall health and well-being, making
                physical activity an enjoyable part of their daily routine.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Space for Social and Emotional Growth
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Beyond physical activity, the SLV INTERNATIONAL SCHOOL
                playground is a nurturing environment for social and emotional
                development. It offers ample space for group play, where
                students learn to cooperate, negotiate, and resolve conflicts,
                building essential social skills. The playground's design
                includes shaded areas and seating where students can gather and
                engage in conversations, fostering friendships and emotional
                connections. Regular supervision by trained staff ensures a safe
                environment where students feel secure to express themselves and
                interact with peers. By providing a supportive and stimulating
                playground, we help students develop resilience, empathy, and a
                positive attitude towards physical and social challenges.
              </div>
            </Grid>
          </Grid>
        </div>

        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
              marginTop: "50px",
            }}
          >
            Basketball court
          </div>
        </div>

        <div className="aboutabout" style={{ marginTop: "-50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Hub for Teamwork and Excellence
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                The basketball court serves as a vibrant hub where students come
                together to enhance their physical and mental well-being. With
                its spacious layout and modern amenities, it caters to players
                of all skill levels, from beginners to advanced athletes. It’s
                not just a court but a space where leadership, perseverance, and
                camaraderie are nurtured through sportsmanship. Our dedicated
                coaches guide students in mastering techniques and strategies
                while instilling the values of fair play and determination. The
                court symbolizes SLV International School’s commitment to
                holistic development, fostering an environment where young
                learners thrive both on and off the court.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Basketball Court at SLV International School
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our state-of-the-art basketball court at SLVIS International
                School provides an exceptional space for students to develop
                athletic skills and foster teamwork. Designed with international
                standards in mind, the court features premium-quality flooring
                that ensures excellent grip and shock absorption, minimizing the
                risk of injuries. Clearly marked boundary lines and
                high-performance basketball hoops make it ideal for training,
                practice sessions, and competitive matches. Surrounding the
                court is ample seating, allowing spectators to enjoy the games
                in comfort. Whether for school tournaments or casual play, the
                facility inspires a passion for basketball while promoting
                fitness and discipline among our students.
              </div>
            </Grid>
          </Grid>
        </div>

        <div
          className="aboutabout"
          style={{
            fontSize: state.auth.isMobile ? "18px" : "22px",
            marginBottom: "80px",
            marginTop: "100px",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color: themeStyle.primaryColor,
            }}
          >
            Swimming Pool
          </div>
        </div>

        <div className="aboutabout" style={{ marginTop: "-50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Swimming Pool at SLV International School
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                Our meticulously designed swimming pool at SLVIS International
                School offers a safe and modern environment for students to
                enjoy aquatic activities. Built to international standards, the
                pool features crystal-clear, temperature-regulated water and
                non-slip decking for enhanced safety. With lanes marked for
                different skill levels, it accommodates beginners learning basic
                strokes and advanced swimmers honing their techniques. Certified
                lifeguards and trained instructors ensure a secure and guided
                experience for all participants. The pool serves as a
                cornerstone for physical fitness, providing opportunities for
                swimming lessons, water sports, and relaxation while promoting
                health, discipline, and confidence in our students.
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="aboutabout">
          <Grid container spacing={5}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div
                style={{
                  fontSize: "28px",
                  fontFamily: "Montserrat",
                  textAlign: "left",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                A Gateway to Aquatic Excellence
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                The swimming pool is more than just a recreational facility;
                it’s a space where students discover the joys of swimming while
                building life-saving skills. Our structured programs encourage
                goal setting, resilience, and teamwork, key attributes for
                personal growth. The serene and inviting atmosphere fosters
                mental well-being, making it an ideal place for both competitive
                and leisure swimming. Regularly maintained with advanced
                filtration systems, the pool reflects SLVIS International
                School’s commitment to hygiene and excellence. Whether
                participating in inter-school competitions or enjoying a
                refreshing swim, students benefit from a holistic experience
                that supports their overall development.
              </div>
            </Grid>
          </Grid>
        </div>

        <Benchmark />
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
